<template>
  <div class="export-actions">
    <div class="buttons-y">
      <button
        type="button"
        @click.passive="startExport('download')"
      >
        <IconDownload/>
        <span>Download</span>
      </button>

      <button
        v-if="webShareApiSupported"
        type="button"
        class="button--secondary"
        @click.passive="startExport('share')"
      >
        <IconShare/>
        <span>Deel</span>
      </button>

      <button
        v-if="clipboardApiSupported"
        type="button"
        class="button--secondary"
        @click.passive="startExport('copy')"
      >
        <IconCopy/>
        <span>Kopieer naar klembord</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useClipboardItems, useShare } from '@vueuse/core';
  import IconCopy from '@/components/svg/IconCopy.vue';
  import IconDownload from '@/components/svg/IconDownload.vue';
  import IconShare from '@/components/svg/IconShare.vue';
  import { useFormStore } from '@/stores/useFormStore';
  import { useSystemStore } from '@/stores/useSystemStore';
  import { useToaster } from '@/composables/useToaster';

  const toaster = useToaster();
  const formStore = useFormStore();
  const systemStore = useSystemStore();

  const {
    share,
    isSupported: webShareApiSupported,
  } = useShare();

  const {
    copy,
    isSupported: clipboardApiSupported,
  } = useClipboardItems();

  async function startExport (method: 'download' | 'share' | 'copy') {
    const validationMessage = formStore.getThemeAndColorSelectionValidationMessage();

    if (validationMessage != null) {
      toaster.error(validationMessage);
      return;
    }

    const result = await systemStore.generatePngExport();

    if (result.ok === false) {
      toaster.error(result.message);
      return;
    }

    const { blob, filename } = result;

    if (method === 'share' && webShareApiSupported.value) {
      const file = new File([blob], filename, { type: 'image/png' });

      share({
        files: [file],
      }).catch(() => {
        // User cancelled sharing.
      });

      return;
    }

    if (method === 'copy' && clipboardApiSupported.value) {
      copy([
        new ClipboardItem({
          'image/png': blob,
        }),
      ])
        .then(() => {
          toaster.success('Afbeelding gekopieerd naar klembord.');
        })
        .catch(() => {
          toaster.error('Kon de afbeelding niet naar het klembord kopiëren.');
        });

      return;
    }

    systemStore.downloadPng(blob, filename);
  }
</script>

<style lang="scss">
  .export-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .buttons-x {
      > * {
        min-width: 0;
      }

      button {
        flex: 1 1 0;
      }
    }


  }
</style>
